import doc                                from '@widesk-core/decorators/doc';
import AccountServiceModel                from '@/models/AccountServiceModel';
import RequestChangeSubscriptionModel     from '@models/account/RequestChangeSubscriptionModel';

@doc.path('/account_subscriptions/request_change_subscriptions')
export default class RequestChangeSubscriptionCreateModel extends AccountServiceModel {
	@doc.string declare authenticationUrl: string;
	@doc.string declare paymentUrl: string;
	@doc.model(RequestChangeSubscriptionModel) declare requestChangeSubscription: RequestChangeSubscriptionModel;
}
